import { Draft } from "immer"
import { useImmerReducer } from "use-immer"
import { styled, CSSFn, callCSSFn, StyleProps } from "../styles"
import { flexCss } from "../Flex"
import { RootContextType, TabsAction, TabsState } from "./types"
import { createContext } from "../utils"

const [Provider, useContext] = createContext<RootContextType>(`Tabs`)

export const useTabs = useContext

type RootOwnProps = Omit<TabsState, "selectedTab"> &
  Readonly<{
    css?: CSSFn
    dataTestId?: string
  }>

export type RootProps = React.ComponentPropsWithRef<"div"> & RootOwnProps

export const Root = ({ children, defaultValue, onValueChange, value, dataTestId }: RootProps) => {
  const [state, dispatch] = useImmerReducer<TabsState, TabsAction>(reducer, {
    selectedTab: defaultValue,
    defaultValue,
    onValueChange,
    value,
  })
  return (
    <Provider state={state} dispatch={dispatch}>
      <Container data-testid={dataTestId}>{children}</Container>
    </Provider>
  )
}

const Container = styled.div<RootProps>((props: RootProps & StyleProps) => ({
  ...flexCss,
  width: `100%`,
  flexGrow: 0,
  flexDirection: `column`,
  ...callCSSFn(props),
}))

function reducer(state: Draft<TabsState>, action: TabsAction): TabsState {
  switch (action.type) {
    case `selectTab`:
      return { ...state, selectedTab: action.tab }
    default:
      return state
  }
}
